import { cx } from '../../lib/utils'

/**
 * Il simbolo (la matrice 2x2 con il quadrante ambra) e il nome, come un unico blocco.
 * In scuro i tre quadrati navy diventano parchment, come ogni colore di struttura
 * (brand kit §3.4); l'ambra resta uguale.
 * Provvisorio: il lockup ufficiale esiste solo in PNG e i PNG del kit sono corrotti,
 * quindi il nome è composto qui finché non arriva un SVG del logo intero.
 */
export default function Logo({
  className,
  wordmark = true,
  size = 'md',
}: {
  className?: string
  wordmark?: boolean
  size?: 'md' | 'lg'
}) {
  return (
    <span className={cx('inline-flex items-center', size === 'lg' ? 'gap-3' : 'gap-2', className)}>
      <svg viewBox="0 0 100 100" className={size === 'lg' ? 'size-9' : 'size-6'} aria-hidden="true">
        <rect x="4" y="4" width="44" height="44" rx="2" className="fill-primary-600 dark:fill-gray-50" />
        <rect x="52" y="4" width="44" height="44" rx="2" className="fill-amber-500" />
        <rect x="4" y="52" width="44" height="44" rx="2" className="fill-primary-600 dark:fill-gray-50" />
        <rect x="52" y="52" width="44" height="44" rx="2" className="fill-primary-600 dark:fill-gray-50" />
      </svg>
      {wordmark && (
        <span
          className={cx(
            'font-sans font-semibold tracking-tight text-primary-600 dark:text-gray-50',
            size === 'lg' ? 'text-2xl' : 'text-[17px]',
          )}
        >
          ScaleBrain
        </span>
      )}
    </span>
  )
}
